import { render, staticRenderFns } from "./StaleStatus.vue?vue&type=template&id=3fe9f0a8&scoped=true&"
import script from "./StaleStatus.vue?vue&type=script&lang=js&"
export * from "./StaleStatus.vue?vue&type=script&lang=js&"
import style0 from "./StaleStatus.vue?vue&type=style&index=0&id=3fe9f0a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe9f0a8",
  null
  
)

export default component.exports